import './scss/bootstrap.scss';
import './scss/fontawesome.scss';
import './scss/spinao.scss';

import * as Lightgallery from './js/Spinao/lightgallery';
import "./js/bootstrap/carousel";
import "./js/bootstrap/dropdown";
import "./js/bootstrap/collapse";
import './js/Spinao/HoverDisplay';
import * as AnimatedAnchors from './js/Spinao/AnimatedAnchors';
import * as AnchorActivation from './js/Spinao/AnchorActivation';
import BSCustomFileInput from './js/bootstrap/CustomFileUpload/index';
import * as DatePicker from "./js/Spinao/DatePicker";
import * as GroupFilter from "./js/Spinao/GroupFilter";
//import * as StickyTopMenu from './js/Spinao/StickyTopMenu';
import * as UnifyHeight from './js/Spinao/UnifyHeight';
import * as UnifyHeight2 from './js/Spinao/UnifyHeight2';
import * as BackToTop from './js/Spinao/BackToTop';
import * as EUCookie from './js/Spinao/EUCookie';
import * as GoogleMaps from './js/Spinao/GoogleMaps';
import * as GoogleReCaptcha from './js/Spinao/GoogleReCaptcha';
import * as Offside from './js/offside';
import * as NetteAjaxForm from './js/Spinao/NetteAjaxForm';
import * as ClassSwitch from "./js/Spinao/ClassSwitch";
import "./js/Spinao/GoogleTagManagerCarousel";
import "./js/Spinao/CookieConsent";

document.addEventListener("DOMContentLoaded", function() {
    ClassSwitch.run();
    AnimatedAnchors.run();
    AnchorActivation.run();

    Offside.initialize('navbarCollapse', {
        buttonsSelector: '.js-offcanvas-trigger'
    });

    Lightgallery.applyTo('#js-lightgallery', {
        selector:'.js-lightgallery-image',
        fullScreen:false,
        zoom:false,
        hash:false,
        pager:false
    });

    //StickyTopMenu.initialize();

    UnifyHeight.applyTo('.js-unify-height');
    UnifyHeight2.applyTo('.js-unify-height2');

    BackToTop.applyTo('backtotop_js');

    EUCookie.initialize();

    NetteAjaxForm.initialize('[data-ajax="form"]');

    BSCustomFileInput.init();

    GoogleMaps.initialize();
    GoogleReCaptcha.initialize();
    DatePicker.initialize();
    GroupFilter.initialize();
});
